var TextToSpeech = {
	initVoice: function(text){
		var v = new SpeechSynthesisUtterance();
		v.text = text
		v.voiceURI = 'native'
		v.lang = 'en-US';
		v.rate = 0.9;
		v.pitch = 1.1;
		v.onstart = this.startSpeaking;
		v.onend = this.stopSpeaking;

		return v
	}
	
}
module.exports = TextToSpeech;


// WEBPACK FOOTER //
// ./modules/lib/interface/TextToSpeech.js